module.exports = __webpack_public_path__ + "img/upslope-2.8866f38f.jpeg";